import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Product.css";
import { FaArrowRightLong } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    content:
      "“ Akscel has completely transformed our development process. We're building applications in a fraction of the time, with higher quality than ever before.”",
    footerIcon: "images/AvatharIcon.png",
    footerText: " - Head of Data Science,",
    footername: "Enterprise Company",
  },
  {
    content:
      "“ The Data Platform's ability to unify our disparate data sources has been a game-changer for our analytics team. We're finally getting a clear picture of our business.”",
    footerIcon: "images/AvatharIcon.png",
    footerText: "- Vp Engineering,",
    footername: "Tech Startup",
  },
];


const flipVariant = {
  initial: {
    rotateY: -90,
    opacity: 0,
  },
  animate: {
    rotateY: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeInOut",
    },
  },
  exit: {
    rotateY: 90,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: "easeInOut",
    },
  },
};

const Products = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    setCurrentSlide((prev) =>
      prev < testimonials.length - 1 ? prev + 1 : prev
    );
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const isMobile = window.innerWidth <= 768; // Tablet and Mobile
  const cardsToShow = isMobile ? 1 : 3;

  const progressPercentage = ((currentSlide + 1) / testimonials.length) * 100;

  return (
    <div className="p_container">
      {/* Section 1 */}
      <div className="P_sec1">
        <img className="acksecl_p_img" src="images/AkscelPimg.png" alt="" />
        <h1>Unlock Unprecedented Speed with Intelligent Automation.</h1>
        <p>
          Akscel combines rapid application code generation with a powerful data
          platform to allow organizations to build applications faster and make
          more informed decisions.
        </p>
        <button onClick={() => navigate("/contact")}>
          Schedule a demo
          <FaArrowRightLong className="psec1arrowp" />
        </button>
      </div>

      {/* Section 2 Akscel Users */}

      <div className="P_sec3">
        <section className="P_sec3_left">
          <h3>What is Akscel</h3>
          <p>
            Akscel is a platform that empowers organizations to rapidly build
            and deploy applications with minimal resources—cost, time, effort,
            and human resources. It also allows organizations to get a 360
            degree view of their data and make informed decisions. Akscel has
            two components - the application platform and the data platform.
          </p>
        </section>
        <section className="P_sec3_right">
          <img
            className="p_sec3_img1"
            src="images/p_sec3_img1.png"
            alt="AI Application Development Solutions for Enterprises"
          />
        </section>
      </div>

      <div className="P_sec2">
        <section className="P_sec2_left">
          <video
            className="H_Video_section"
            src="https://arshil-website.s3.us-east-1.amazonaws.com/akscel-video/Akscel+Website+Video..mp4"
            controls
            autoPlay
            muted
            loop
          />
        </section>

        <section className="P_sec2_right">
          <h3 className="P_sec2_right_h3">
            Akscel Users in a New Era of Software Development
          </h3>
          <p className="P_sec2_right_p1">
            Launching an application once felt like navigating a maze, with
            weeks spent wrestling with code and systems, hoping everything would
            work. Those days are fading as innovation transforms the process.
            Now, you can launch ideas in days instead of months. Testing,
            including unit and regression, becomes a seamless and fast part of
            the workflow.
          </p>
          <p className="P_sec2_right_p2">
            Akscel makes this possible by igniting your entire DevOps pipeline
            with a single click, turning development into a smooth and
            effortless process.
          </p>
          <p className="P_sec2_right_p3">
            This is not just about speed. Akscel removes manual constraints and
            uses intelligent automation to deliver applications faster and at a
            lower cost, with automated API generation and accelerated testing.
            Akscel empowers organizations to build the future with ease and
            efficiency.
          </p>
        </section>
      </div>

      {/* Section4 Akscel Application Platform */}

      <div className="P_sec4">
        <section className="p_sec4_right p_sec4_right_tab">
          <img className="p_sec4_img1" src="images/p_sec4_img1.png" alt="" />
        </section>
        <section className="p_sec4_left">
          <h2>Akscel Application Platfrom</h2>
          <p className="p_sec4_left_p1">
            Akscel application platform is a comprehensive application
            development platform that generates source code in multiple
            programming languages that can be deployed in a data center or any
            public cloud. <br></br> Akscel Application Platform empowers
            organizations to launch innovative solutions, not just write lines
            of code.
          </p>
          <h4 className="p_sec4_left_h4">What This Means for Organization:</h4>
          <ul className="p_sec4_left_ul">
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                Unleash Your Vision, Faster:
              </span>{" "}
              Go from concept to working application in days, not months. See
              your ideas take shape at a speed you never thought possible.
            </li>
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                Innovate Without Limits:
              </span>{" "}
              Focus on what truly matters, building groundbreaking solutions
              while Akscel handles the heavy lifting of code generation
            </li>
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                Future-Proof Your Development:
              </span>{" "}
              Build on a platform designed for scalability and flexibility,
              ensuring your applications can grow and adapt with your business.
            </li>
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">Empower Your Team:</span>{" "}
              Free your developers from tedious tasks, allowing them to
              concentrate on creativity and solving complex challenges.
            </li>
          </ul>
        </section>
        <section className="p_sec4_right p_sec4_right_tab_v">
          <img className="p_sec4_img1" src="images/p_sec4_img1.png" alt="" />
        </section>
        <section className="p_sec4_left p_sec4_left_second">
          <h2>Akscel Data Platfrom</h2>
          <p className="p_sec4_left_p1">
            Akscel data platform is a cloud native metadata driven data
            analytics platform that automates the ingestion, curation and
            processing of data from multiple sources to provide a 360 degree
            view of the data. <br></br> Akscel Data Platform transforms raw data
            into actionable intelligence, giving you the unshakeable confidence
            to make critical decisions.
          </p>
          <h4 className="p_sec4_left_h4">What This Means for Organization:</h4>
          <ul className="p_sec4_left_ul">
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                Unlock the Power of Your Data:
              </span>{" "}
              Break free from data silos. Akscel effortlessly connects to your
              diverse data sources, providing a unified, comprehensive view of
              your business.
            </li>
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                Insights You Can Trust:
              </span>{" "}
              Stop second-guessing your data. Automated cleaning and preparation
              ensure accuracy and consistency, providing a solid foundation for
              confident decision-making.
            </li>
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                See the Bigger Picture:
              </span>{" "}
              Go beyond surface-level analysis. Akscel's automated metadata
              discovery and powerful data transformation reveal the hidden
              patterns and opportunities within your data..
            </li>
            <li className="p_sec4_left_li">
              <span className="p_sec4_left_li_span">
                {" "}
                Make Decisions in Real-Time:
              </span>{" "}
              React with agility. Harness the power of real-time data streaming
              and processing to make informed decisions the moment they matter
              most.
            </li>
          </ul>
        </section>
        <section className="p_sec4_right">
          <img className="p_sec4_img1" src="images/p_sec4_img2.png" alt="" />
        </section>
      </div>

      {/* Section 5 Akscel Data Platform */}

      <div className="p_sec6">
        <section className="p_sec6_left">
          <img className="p_sec6_img1" src="images/p_sec6_img1.png" alt="" />
        </section>

        <section className="p_sec6_right">
          <h2 className="p_sec6_right_h2">
            How Akscel Transforms Organizations
          </h2>
          <p className="p_sec6_right_p1">
            The true strength of Akscel comes from the seamless collaboration
            between its Application and Data Platforms. It’s not just about
            building faster or understanding data better; it’s about the synergy
            created when these components unite.
          </p>
          <p className="p_sec6_right_p2">
            With Akscel, you develop applications with data insights integrated
            from the start. You validate assumptions and iterate quickly based
            on real-time feedback. Now, orgranizations can build smarter and
            decide faster. Akscel enables your organization to operate with
            unmatched agility, turning ideas into impactful, data-driven
            solutions at incredible speed.
          </p>
        </section>
      </div>

      {/* Section 7 what our users */}

      <div className="testimonial_container">
        <h1>What Our Users Are Saying</h1>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentSlide}
            className="card"
            variants={flipVariant}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <img src="images/el_quotes.png" alt="Quotes" />
            <p>{testimonials[currentSlide].content}</p>
            <div className="iconwithText">
              <span className="iconwithText_icon">
                <img
                  src="svg/Testimonials_Avathar_icon.svg"
                  alt="User avatar"
                />
              </span>
              <div className="text-content">
                <h6>{testimonials[currentSlide].footerText}</h6>
                <h6>{testimonials[currentSlide].footername}</h6>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="buttons_progressbar_container">
          <div className="controls">
            <button onClick={handlePrev} disabled={currentSlide === 0}>
              &lt;
            </button>
            <button
              onClick={handleNext}
              disabled={currentSlide === testimonials.length - 1}
            >
              &gt;
            </button>
          </div>
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>
      </div>

      <div className="Sec8_container">
        <section
          data-aos="fade-up-right"
          data-aos-duration="1200"
          data-aos-easing="ease-in-out"
        >
          <h1>Ready to experience the future of software development?</h1>
          <p>
            See how Akscel can transform your organization, accelerate your time
            to market, and empower you to build the next generation of impactful
            solutions.
          </p>
        </section>

        <section
          className="Sec8_container_button"
          data-aos="zoom-out"
          data-aos-delay="500"
          data-aos-duration="1400"
        >
          <button onClick={() => navigate("/contact")}>
            Schedule a Demo
            <FaArrowRightLong className="sec8Carrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Products;
